export default "__VITE_ASSET__BWwcDf4S__"